module.exports = __webpack_public_path__ + "static/media/over-jeu.083fa052.svg";